import * as images from "@/components/images/Images";
import { ServicesHeroQualityData } from "./types";
import { ROUTES } from "@/constants";

const servicesHeroQuality = {
  title: "100% translation quality guarantee",
  description:
    "We are committed to achieving the highest translation quality possible through a network of elite translators, rigorous quality control mechanisms, and unlimited free revisions.",
  primaryButton: {
    href: ROUTES.startOrder,
    label: "Start order",
  },
} as ServicesHeroQualityData;

export const servicesHeroQualityMap = {
  quality: servicesHeroQuality,
};
